import request from '@/request/ts-index';
var SearchApi;
(function (SearchApi) {
    SearchApi["searchHints"] = "/search/hints";
    SearchApi["searchHots"] = "/search/hots";
    SearchApi["searchpages"] = "/search/searchpages";
    SearchApi["searchDetailById"] = "/search/searchDetail";
    SearchApi["searchRel"] = "/search/searchRel";
})(SearchApi || (SearchApi = {}));
// 搜索底纹
export const searchHints = (params) => {
    return request.get(SearchApi.searchHints, {
        params
    });
};
// 热搜词
export const searchHots = (params) => {
    return request.get(SearchApi.searchHots, {
        params
    });
};
// 彩铃搜索
export const searchPages = (params) => {
    return request.get(SearchApi.searchpages, {
        params
    });
};
// 彩铃搜索
export const searchDetailById = (params) => {
    return request.get(SearchApi.searchDetailById, {
        params
    });
};
// 彩铃搜索
export const searchRel = (params) => {
    return request.get(SearchApi.searchRel, {
        params
    });
};
